export const gradeUnits = {
  1: [
    { id:"g1_num_place",  title:"Count to 120",       icon:"🔢", order:1 },
    { id:"g1_add_sub20",  title:"Add & Sub ≤20",      icon:"➕", order:2 },
    { id:"g1_shapes",     title:"2‑D Shapes",          icon:"🔺", order:3 },
    { id:"g1_measure",    title:"Compare Length",      icon:"📏", order:4 },
    { id:"g1_time",       title:"Time to ½‑Hour",      icon:"⏰", order:5 },
    { id:"g1_data",       title:"Picture Graphs",      icon:"📊", order:6 },
  ],

  2: [
    { id:"g2_place1000",   title:"Place Value ≤1000",   icon:"💯", order:1 },
    { id:"g2_add_regroup", title:"Regrouping ±",        icon:"➕", order:2 },
    { id:"g2_arrays",      title:"Multiplication Arrays",icon:"🔲", order:3 },
    { id:"g2_fractions",   title:"Halves & Quarters",    icon:"🌓", order:4 },
    { id:"g2_money",       title:"Money up to $1",       icon:"💰", order:5 },
  ],

  3: [
    { id:"g3_mult_facts",  title:"Times Tables 0‑10",    icon:"✖️", order:1 },
    { id:"g3_frac_line",   title:"Fractions on Line",    icon:"📏", order:2 },
    { id:"g3_equiv_frac",  title:"Equivalent Fractions", icon:"🌓", order:3 },
    { id:"g3_area_rect",   title:"Rectangle Area",       icon:"📐", order:4 },
    { id:"g3_perimeter",   title:"Perimeter",            icon:"📏", order:5 },
    { id:"g3_angles",      title:"Angle Basics",         icon:"📐", order:6 },
  ],

  4: [
    { id:"g4_multi_digit", title:"4‑Digit ±",            icon:"➕", order:1 },
    { id:"g4_long_div",    title:"Long Division",        icon:"➗", order:2 },
    { id:"g4_frac_add",    title:"Add Fractions",        icon:"➕", order:3 },
    { id:"g4_decimals",    title:"Decimals 0.01",        icon:"🔟", order:4 },
    { id:"g4_area_compo",  title:"Composite Area",       icon:"📐", order:5 },
    { id:"g4_angle_measure",title:"Measure Angles",      icon:"📏", order:6 },
  ],

  5: [
    { id:"g5_dec_ops",     title:"Decimal × ÷",          icon:"✖️", order:1 },
    { id:"g5_frac_mult",   title:"Fraction × Fraction",  icon:"✖️", order:2 },
    { id:"g5_volume",      title:"Prism Volume",         icon:"📦", order:3 },
    { id:"g5_line_plots",  title:"Line Plots",           icon:"📈", order:4 },
    { id:"g5_patterns",    title:"Number Patterns",      icon:"🔢", order:5 },
  ],

  6: [
    { id:"g6_ratio",       title:"Ratios & Rates",       icon:"⚖️", order:1 },
    { id:"g6_int_plane",   title:"Integers Plane",       icon:"➕", order:2 },
    { id:"g6_frac_div",    title:"Fraction ÷ Fraction",  icon:"➗", order:3 },
    { id:"g6_surface",     title:"Surface Area",         icon:"📦", order:4 },
    { id:"g6_stats",       title:"Statistics & Prob",    icon:"🎲", order:5 },
    { id:"g6_expressions", title:"Expressions & Eq",     icon:"📝", order:6 },
  ]
};
